import { Pagination } from 'react-admin';
import React from 'react';

export const CustomPagination = props => <Pagination rowsPerPageOptions={[50, 25, 10]} {...props} />;
